import { IAnalytcisUserInput } from '../types/IAnalyticsUserInput';
import { ReportsUserInput } from '../types/reports';

export const analyticsUserInput: IAnalytcisUserInput = {
  TidalLevel: {
    dataset: null,
    variable: null,
    startDate: null,
    endDate: null,
  },
  TimeSeriesPlot: {
    dataset: null,
    variable: null,
    startDate: null,
    endDate: null,
  },
  ScatterPlot: {
    xAxisInterval: 1,
    yAxisInterval: 50,
    month: 0,
    datasetX: null,
    datasetY: null,
    variableX: null,
    variableY: null,
    variablesX: null,
    variablesY: null,
    startDate: null,
    endDate: null,
  },
  RosePlot: {
    directionalDataset: null,
    month: 0,
    dataset: null,
    variable: null,
    variablesX: null,
    variablesY: null,
    direction: null,
    startDate: null,
    endDate: null,
    directionNo: 12,
    legendInterval: 0,
  },
  ScatterTable: {
    datasetX: null,
    datasetY: null,
    variableX: null,
    variableY: null,
    variablesY: null,
    startDate: null,
    endDate: null,
    month: 'All',
    intervalX: 24,
    intervalY: 24,
  },
  Persistence: {
    datasetX: null,
    datasetY: '',
    variableX: null,
    variableY: null,
    variablesY: null,
    sign: 'below',
    sign2: 'below',
    percentile: 50,
    duration: 1,
    threshold: null,
    threshold2: null,
    startDate: null,
    endDate: null,
    conditionalDSSelected: false,
  },
  ExtremeValues: {
    dataset: null,
    variable: 0,
    startDate: null,
    endDate: null,
  },
  Histogram: {
    dataset: null,
    datasetY: null,
    month: 'All',
    variableX: null,
    variablesY: null,
    variableY: null,
    startDate: null,
    endDate: null,
    directionalInterval: 16,
    magnitudeInterval: 16,
  },
  Statistics: {
    dataset: null,
    variable: null,
    startDate: null,
    endDate: null,
  },
  Exceedance: {
    dataset: null,
    variable: null,
    startDate: null,
    endDate: null,
  },
  AltimeterComparison: {
    dataset: null,
    variable: null,
    startDate: null,
    endDate: null,
  },
};

export const initialReportsUserInput: ReportsUserInput = {
  datasetSW: null,
  datasetHD: null,
  datasetWind: null,
  timeStep: '60',
  startDate: null,
  endDate: null,
};
